export default {
  unknown_error: 'Возникла непредвиденная ошибка сервера. Пожалуйста, воспользуйтесь формой обратной связи.',
  captcha_error: 'Подтвердите, что Вы не робот!',
  continue: 'Продолжить',
  submit: 'Отправить',
  learn_more: 'Подробно',
  clear: 'Очистить',
  cancel: 'Отменить',
  search: 'Поиск',
  search_by_number: 'Поиск по списку',
  product_code: 'Артикул',
  product_name: 'Наименование',
  no_vat: 'без НДС',
  price: 'Цена',
  price_rub: 'Цена руб.',
  sum_rub: 'Сумма руб.',
  total_vat_rub: 'Итого с НДС руб.',
  total_rub: 'Итого руб.',
  vat_rub: 'НДС (22%) руб.',
  quantity: 'Количество',
  quantity_short: 'Кол-во',
  profile: 'Профиль',
  login: 'Логин',
  first_name: 'Имя',
  last_name: 'Фамилия',
  company_name: 'Название компании',
  company_ownership: 'Форма собственности',
  phone: 'Номер телефона',
  country_phone: 'Страна и номер телефона',
  inn: 'ИНН',
  kpp: 'КПП',
  set_password: 'Задайте пароль',
  confirm_password: 'Повторите пароль',
  news: 'Новости',
  all_news: 'Все новости',
  orders: 'Заказы',
  favourites: 'Избранное',
  add_favourites: 'Добавить в избранное',
  remove_favourites: 'Удалить из избранного',
  in_favourites: 'Товар в избранном',
  to_homepage: 'На главную',
  cart: 'Корзина',
  go_to_cart: 'Перейти в корзину',
  express: 'Экспресс',
  prev_btn: 'Назад',
  next_btn: 'Далее',
  price_requests: 'Мои запросы',
  search_history: 'История загрузок списком',
  print: 'Печать',
  save: 'Сохранить',
  specialization: 'Специализация',
  all_vehicles: 'Все типы ТС',
  where_to_buy: 'Где купить?',
  list_of_distributors: 'Список дистрибьюторов',
  download_order_file: 'Скачать файл заказа',
  select_distributor: 'Выбрать дистрибьютора',
  maker_engine: 'Производитель',
  model_engine: 'Модель двигателя',
  show: 'Показать',
  applicability: 'Применяемость',
  mark: 'Марка',
  model: 'Модель',
  year_manufacture: 'Год выпуска',
  engine: 'Двигатель',
  makers: 'Производители',
  apply: 'Применить',
  apply_filters: 'Применить фильтры',
  all_products: 'Показать все',

  quantity_pcs: "Количество мест шт.",
  add_comment: "Добавить комментарий",
  // order_checkout_manager_contact_text: 'Отправьте заказ и наш менеджер свяжется с Вами в ближайшее время. Сумма указана без стоимости доставки',
  print_document: "Печать документов",
  delete_cart: "Очистить корзину",
  empty_cart: "Ваша корзина пуста.",
  delete_cart_confirm_1: "Вы уверены, что хотите очистить корзину?",
  delete_cart_confirm_2: "Подтвердите действие!",
  checkout_confirm_1: "Подтвердите отправку заказа!",
  checkout_confirm_2: "После отправки заказ изменить нельзя!",
  checkout_success_header: "Ваш заказ отправлен!",
  checkout_success_text_1: "Менеджер свяжется с Вами в ближайшее время.",
  checkout_success_text_1_retailer:
    "Менеджер дистрибьютора свяжется с Вами в ближайшее время.",
  checkout_success_text_2:
    "На адрес электронной почты, указанный при регистрации на сайте, отправлено письмо с файлом заказа. Если письмо не пришло, проверьте папку Спам.",
  checkout_distributors_list_1:
    "Ваш заказ будет отправлен следующим дистрибюторам:",
  checkout_distributors_list_2: "Изменить дистрибьюторов можно в",
  checkout_distributors_list_3: "Личном кабинете",
  added_pcs: "добавлено",
  deleted_pcs: "удалено",
  pcs: "шт.",
  products_moved_warning:
    "Внимание! Из-за изменения количества товаров на складе, были изменены следующие позиции:",
  print_cart: "Печать корзины",

  page_title: "Заказы - Личный кабинет",
  search_by_order_number_product: "Название товара, артикул, номер заказа",
  dates: "Даты",
  period: "Период",
  availability: "Доступность",
  stock: "Склад",
  stock_pcs: "Склад, шт.",
  store_pcs: "Наличие, шт.",
  stock_type_available: "В наличии",
  stock_type_transit: "В пути",
  stock_type_preorder: "Под заказ",
  stock_type_available_mobile: "В нал.",
  stock_type_transit_mobile: "В пути",
  stock_type_preorder_mobile: "Под заказ",
  period_all: "За все время",
  period_today: "Сегодня",
  period_yesterday: "Вчера",
  period_week: "Неделя",
  // period_week: 'Текущая неделя',
  period_lastweek: "Прошлая неделя",
  period_month: "Месяц",
  // period_month: 'Текущий месяц',
  period_lastmonth: "Прошлый месяц",
  period_year: "Год",
  // period_year: 'Текущий год',
  period_lastyear: "Прошлый год",

  open_orders: "Открытые заказы",
  shipment: "Отгрузки",
  orders_history: "История заказов",
  orders_history_phone: "История",

  orders_open: "Открытые заказы",
  available: "Доступно",
  order_number: "Заказ №",
  date: "Дата",
  date_order: "Дата заказа",
  status: "Статус",
  statuses: "Статусы",
  position_qnt: "Количество позиций",
  order_save: "Сохранить заказ",

  oo_download_excel: "Выгрузить список открытых заказов",
  oo_manager_shipment_notify: "Отгрузить все доступные заказы",
  total_without_vat: "Итого рублей без НДС:",
  total_without_vat_phone: "Итого:",

  manager_shipment_notify:
    "Оповестить менеджера о необходимости отгрузки товаров в наличии",
  manager_shipment_notified: "Mенеджер свяжется с вами в ближайщее время",

  delivery_deadline: "срок поставки на склад в Москве",
  delivery_deadline_from: "срок поставки на склад в Москве от",
  delivery_deadline_to: "срок поставки на склад в Москве до",
  day_1: "день",
  day_2: "дня",
  day_3: "дней",

  shipments: "Отгрузки",
  delivery_date: "Дата отгрузки",
  number: "Номер",
  total_shipment: "Сумма отгрузки руб. без НДС",
  debt: "Долг руб.",
  date_payment: "Дата оплаты",
  documents: "Документы",

  brand: "Бренд",
  transit_delivery:
    'дата поставки будет доступна после оформления заказа во вкладке "Открытые заказы"',

  product_added_to_cart: "Товар добавлен в корзину.",
  product_added_to_fav: "Товар добавлен в избранное.",
  product_removed_from_fav: "Товар удален из избранного.",
  add_any_quantity: "добавьте в корзину любое количество",
  amount_updated_date: "Остатки актуальны на дату: ",
  requested_quantity: "Кол-во, шт.",
  pdf_download_remains: "Отстатки и цены",
  pdf_download_crosses: "Кроссы",
  expected_shipment_date: "Ожидаемая дата поставки",
  pcs_transit: "шт. в пути",

  city: "Город",
  main_distributor: "Основной дистрибьютор",
  main_distributor_address: "Адрес основного дистрибьютора",
  add_distributors: "Добавить дистрибьюторов",

  to_apply_discount:
    "Для применения скидки {discount}% необходимо увеличить количество товара до {min_qnt} шт",
  // articul: "Товар",
  discount_min_qnt: "Минимальное кол-во",
  discount_value: "Скидка %",
  on_request: 'По запросу',
  payment_standard: 'Оплата по условиям действующего договора',
  discount_rub: 'Сумма скидки руб',
  discounted_rub: 'Сумма со скидкой руб',

  rub: 'руб',
}
